exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-attribute[data-v-34d3f0f6]{cursor:default;position:absolute;bottom:0;right:0;left:0;z-index:5;color:#fff;font-size:12px;line-height:16px;text-transform:uppercase;text-align:center;letter-spacing:1px;padding:5px 10px}.product-attribute.sold[data-v-34d3f0f6]{background-color:#000}.product-attribute.new[data-v-34d3f0f6]{background-color:#4BDEBB}.product-attribute.new-with-tag[data-v-34d3f0f6]{background-color:#B595C9}.product-attribute.bestseller[data-v-34d3f0f6]{background-color:#F3A1B5}\n", ""]);

// exports
